export default "__VITE_ASSET__25451214__"